import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CookieModalProvider } from "@/components/ui";
import App from "./App";
import "@styles/index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <CookieModalProvider>
      <App />
    </CookieModalProvider>
  </StrictMode>
);
